import React from 'react';

import CountUp from 'react-countup';

import { useInView } from 'react-intersection-observer';

const NumCounter = ({ start, end, duration }) => {
  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0.2,
    triggerOnce: true,
  });

  return (
    <>
      <span ref={ref}>
        {inView ? (
          <CountUp
            start={start || 0}
            end={end}
            duration={duration || 3}
            delay={0}
            separator=','
            useEasing
          />
        ) : null}
      </span>
    </>
  );
};

export default NumCounter;
